<template>
  <AppSmartList
    ref="app-smart-list"
    :breadcrumbData="breadcrumbData"
    :accessRights="accessRights"
    :filters="filters"
    :actions="actions"
    :tableHeaders="headers"
  >
  </AppSmartList>
</template>

<script>
import AppSmartList from "@/views/components/bases/smart/AppSmartList.vue";
import commonMixin from "@/core/mixins/common.mixin";
import { i18nHelper } from "@/core/utils";
import { ROUTE_NAME } from "@/core/constants";
import {
  HOME_GET_APPS,
  HOME_INITIAL_GET_APPS_STATE,
} from "@/core/store/home.module";

export default {
  name: "AccountLoggerList",
  components: {
    AppSmartList,
  },
  mixins: [commonMixin],
  data: () => ({
    breadcrumbData: {
      breadcrumbs: [
        {
          title: i18nHelper.getMessage("label.devOps"),
          route: { name: ROUTE_NAME.DEVOPS_ACCOUNT_LOGGER },
        },
        {
          title: i18nHelper.getMessage("label.accountLogger"),
          route: { name: ROUTE_NAME.DEVOPS_ACCOUNT_LOGGER },
        },
      ],
    },
    actions: {
      viewList: {
        module: "home",
        state: "apps",
        action: HOME_GET_APPS,
        initialStateAction: HOME_INITIAL_GET_APPS_STATE,
        title: i18nHelper.getMessage("label.getApps"),
      },
    },
    accessRights: {},
    filters: [
      {
        label: "appName",
        key: "appName",
      },
    ],
    headers: [
      {
        key: "publicHybrid",
        name: "publicHybrid",
        fixedLeft: true,
      },
      {
        key: "businessUnit",
        name: "businessUnit",
      },
      {
        key: "appName",
        name: "appName",
      },
      {
        key: "accountName",
        name: "accountName",
      },
      {
        key: "createUser",
        name: "createUser",
      },
      {
        key: "createTime",
        name: "createTime",
      },
      {
        key: "region",
        name: "region",
      },
      {
        key: "subnet",
        name: "subnet",
      },
      {
        key: "status",
        name: "status",
        layout: "HomeStatusLabel",
      },
      {
        key: "argoURL",
        name: "argoUrl",
        fixedRight: true,
        headerStyle: "width:100px;",
        active: true,
        layout: "AppTableActions",
        layoutActions: {
          openUrl: true,
        },
      },
    ],
  }),
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style></style>
